import { render, staticRenderFns } from "./ConfigGraduateSeparateThesisCredit.vue?vue&type=template&id=225a8396"
import script from "./ConfigGraduateSeparateThesisCredit.vue?vue&type=script&lang=js"
export * from "./ConfigGraduateSeparateThesisCredit.vue?vue&type=script&lang=js"
import style0 from "./ConfigGraduateSeparateThesisCredit.vue?vue&type=style&index=0&id=225a8396&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports